module.exports = __webpack_public_path__ + "static/media/kombuchaLogo.54557ea0.png";